import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from '@systemeio/file-manager';
import { HelpBots } from 'help-bots';
import Head from 'next/head';
import Router, { useRouter } from 'next/router';
import React from 'react';
import Header from 'shared/components/header';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification';
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification';
import { Snow } from './snow';
import { useChristmas } from './snow/use-christmas';
import { MaintenanceBanner } from 'shared/components/maintenance-banner';
import { useGuard } from 'shared/hooks/use-guard';
const disabledPageRoute = '/disabled';
function DashboardLayout(t0) {
  const $ = _c(16);
  const {
    children,
    browserTabTitle
  } = t0;
  useGuard();
  useEmailStatusNotification();
  usePaymentNotification();
  const christmasFeatureIsOn = useChristmas();
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const {
    isDisabled
  } = useUser();
  if (isDisabled && pathname !== disabledPageRoute) {
    Router.replace(disabledPageRoute);
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HelpBots />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== browserTabTitle || $[2] !== t) {
    t2 = t(browserTabTitle);
    $[1] = browserTabTitle;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Head><title>{t2}</title></Head>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Header />;
    t5 = <MaintenanceBanner />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children) {
    t6 = <div>{t4}{t5}<div className="px-4 sm:px-6 md:px-14"><QueryClientProvider><main className="py-5">{children}</main></QueryClientProvider></div></div>;
    $[8] = children;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== christmasFeatureIsOn) {
    t7 = christmasFeatureIsOn && <Snow />;
    $[10] = christmasFeatureIsOn;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t7) {
    t8 = <>{t1}{t3}{t6}{t7}</>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
export default DashboardLayout;